import React, { Component } from 'react';
import { Col, Form, FormGroup } from 'react-bootstrap';
import Input from 'components/shared/input/Input';
import { Field, reduxForm } from 'redux-form';
import LogoUpload from 'components/shared/logo-upload/LogoUpload';
import StampForm from 'components/shared/stamp/StampForm';
import 'components/admin/service-providers/ServiceProvidersEditForm.css';

class ServiceProvidersEditForm extends Component {
  setLogo = (props, files) => {
    const file = files[0];
    const logo = {
      url: URL.createObjectURL(file),
      file: file,
    };
    props.input.onChange(logo);
  };

  removeLogo = (props) => {
    props.input.onChange({ ...props.input.value, destroy: true });
  };

  logoComponent = (props, logo) => {
    return (
      <LogoUpload
        extensions={['.jpg', '.jpeg', '.gif', '.png']}
        logos={[props.input.value].filter((logo) => !!logo && !logo.destroy)}
        onRemove={() => this.removeLogo(props)}
        onUpload={(files) => this.setLogo(props, files)}
        useDropzone={true}
      />
    );
  };

  handleStampFormChange = (props, attr, value) => {
    props.input.onChange({ ...props.input.value, [attr]: value });
  };

  stampFormComponent = (props) => {
    return (
      <StampForm
        stamp={props.input.value || undefined}
        error={props.meta.error && props.meta.submitFailed}
        onChange={(attr, value) =>
          this.handleStampFormChange(props, attr, value)
        }
      />
    );
  };

  renderInput = (props) => {
    return (
      <Input
        valid={!props.meta.error || !props.meta.submitFailed}
        value={props.input.value}
        onChange={(value) => props.input.onChange(value)}
        {...props}
      />
    );
  };

  render() {
    const {
      initialValues,
      handleSubmit,
      invalid,
      submitFailed,
      onCancel,
    } = this.props;
    return (
      <div className="edit-service-provider">
        <div className="full-title">
          {initialValues ? 'Edit' : 'New'} Company
        </div>
        <Col sm={8} lg={8} className="edit-service-provider-form">
          <Form horizontal onSubmit={handleSubmit}>
            <div className="h2">Company Details</div>
            <FormGroup>
              <Col sm={6}>
                <Field
                  component={this.renderInput}
                  name="name"
                  placeholder="Company Name"
                  type="text"
                />
              </Col>
            </FormGroup>
            <hr />
            <FormGroup>
              <Col sm={6}>
                <Field
                  component={this.renderInput}
                  name="firstName"
                  placeholder="Contact First Name"
                  type="text"
                />
              </Col>
              <Col sm={6}>
                <Field
                  component={this.renderInput}
                  name="lastName"
                  placeholder="Contact Last Name"
                  type="text"
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col sm={6}>
                <Field
                  component={this.renderInput}
                  name="email"
                  placeholder="Email"
                  type="email"
                />
              </Col>
              <Col sm={6}>
                <Field
                  component={this.renderInput}
                  name="phoneNumber"
                  placeholder="Phone Number"
                  type="text"
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col sm={6}>
                <Field
                  component={this.renderInput}
                  name="streetAddress"
                  placeholder="Street Address"
                  type="text"
                />
              </Col>
              <Col sm={6}>
                <Field
                  component={this.renderInput}
                  name="unitNumber"
                  placeholder="Unit number / Floor"
                  type="text"
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col sm={6}>
                <Field
                  component={this.renderInput}
                  name="city"
                  placeholder="City"
                  type="text"
                />
              </Col>
              <Col sm={3}>
                <Field
                  component={this.renderInput}
                  name="state"
                  placeholder="State"
                  type="text"
                />
              </Col>
              <Col sm={3}>
                <Field
                  component={this.renderInput}
                  name="zipCode"
                  placeholder="Zip Code"
                  type="text"
                />
              </Col>
            </FormGroup>

            {invalid && submitFailed && (
              <div className="invalid-message">
                The outlined inputs should be added in order to submit the form.
              </div>
            )}
            <FormGroup className="button-container">
              <Col sm={12}>
                <input
                  className="btn button button-orange"
                  type="submit"
                  value="Save"
                />
                <input
                  className="btn button button-gray"
                  type="button"
                  value="Cancel"
                  onClick={onCancel}
                />
              </Col>
            </FormGroup>
          </Form>
        </Col>
        <Col sm={12} lg={12} className="special-note">
          <div className="special-note-title">
            <span>Company Logo & Stamp</span>
          </div>
          <FormGroup>
            <Field component={this.logoComponent} name="logo" />
          </FormGroup>
          <FormGroup>
            <Field component={this.stampFormComponent} name="stamp" />
          </FormGroup>
        </Col>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};
  if (!values.name) {
    errors.name = 'Required';
  }
  if (!values.firstName) {
    errors.firstName = 'Required';
  }
  if (!values.lastName) {
    errors.lastName = 'Required';
  }
  if (!values.email) {
    errors.email = 'Required';
  }
  if (!values.phoneNumber) {
    errors.phoneNumber = 'Required';
  }
  if (!values.streetAddress) {
    errors.streetAddress = 'Required';
  }
  if (!values.city) {
    errors.city = 'Required';
  }
  if (!values.state) {
    errors.state = 'Required';
  }
  if (!values.zipCode) {
    errors.zipCode = 'Required';
  }
  if (values.stamp && !values.stamp.destroy) {
    const { stamp } = values;
    errors.stamp =
      !stamp.legal ||
      !stamp.stampActions ||
      !stamp.stampActions.find((stampAction) => !stampAction.destroy) ||
      !!stamp.stampActions.find(
        (stampAction) => !stampAction.destroy && !stampAction.title
      );
  }
  return errors;
}

export default reduxForm({
  form: 'ServiceProvidersEditForm',
  validate,
})(ServiceProvidersEditForm);



// WEBPACK FOOTER //
// ./src/components/admin/service-providers/ServiceProvidersEditForm.js